var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrailerCargo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 13.0704V26.8873H9.13992C9.45021 24.5266 11.47 22.7042 13.9155 22.7042C16.361 22.7042 18.3808 24.5266 18.6911 26.8873H27.2254V13.0704C27.2254 10.2701 24.9552 8 22.1549 8H7.07042C4.27011 8 2 10.2701 2 13.0704ZM17.4648 27.7746C17.4648 29.7349 15.8757 31.3239 13.9155 31.3239C11.9553 31.3239 10.3662 29.7349 10.3662 27.7746C10.3662 25.8144 11.9553 24.2254 13.9155 24.2254C15.8757 24.2254 17.4648 25.8144 17.4648 27.7746ZM15.6901 27.7747C15.6901 28.7548 14.8956 29.5493 13.9155 29.5493C12.9354 29.5493 12.1408 28.7548 12.1408 27.7747C12.1408 26.7945 12.9354 26 13.9155 26C14.8956 26 15.6901 26.7945 15.6901 27.7747ZM27.6056 22.4507H29.6338L29.6338 23.4648H36.4789V23.7183H38V24.7324H36.4789V24.9859H29.6338L29.6338 25.7465H27.6056V22.4507ZM34.4507 21.6901V22.9577H35.4648V21.6901H34.4507Z",
    fill: "#575656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailerCargo);
export default __webpack_public_path__ + "static/media/TRAILER_CARGO.6aa90def89027a789432cd6982caa60c.svg";
export { ForwardRef as ReactComponent };